<!--
 * @Author: wsx
 * @Date: 2022-01-12 14:57:29
 * @LastEditTime: 2022-01-20 10:40:50
 * @LastEditors: your name
 * @Description: 新增/编辑用户表单
-->
<template>
  <el-dialog
    v-model="formVisible"
    :title="formTitle"
    @close="close"
    class="clueUserForm"
    :width="status == 3 ? '45%' : '540px'"
  >
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      :disabled="isDisabled"
      label-width="120px"
      class="userForm"
    >
      <template v-if="status == 3">
        <h-anchor class="anchor" :idList="idList">
          <div id="one">
            <div class="formTitle"><span></span>上报人信息</div>
            <el-form-item label="线索标题">
              <el-input v-model="ruleForm.clueTitle"></el-input>
            </el-form-item>
            <el-form-item label="线索类型">
              <el-input v-model="ruleForm.clueTypeDict"></el-input>
            </el-form-item>
            <el-form-item label="线索描述">
              <el-input
                :rows="2"
                type="textarea"
                v-model="ruleForm.clueDescribe"
              ></el-input>
            </el-form-item>
            <el-form-item label="创建时间" prop="cardNumber">
              <el-input
                v-model="ruleForm.createTimeDict"
                placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>
          </div>
          <div id="two">
            <div class="formTitle"><span></span>线索信息</div>
            <el-form-item label="上报人" prop="card">
              <el-input v-model="ruleForm.reportPersonnel"></el-input>
            </el-form-item>
            <el-form-item label="上报人电话" prop="card">
              <el-input v-model="ruleForm.reportTelephone"></el-input>
            </el-form-item>
            <el-form-item label="上报时间" prop="card">
              <el-input v-model="ruleForm.reportTimeDict"></el-input>
            </el-form-item>
            <el-form-item
              label="核实信息"
              prop="card"
              v-if="ruleForm.verifyStats == '1'"
            >
              <el-input
                v-model="ruleForm.verifyDescribe"
                :rows="2"
                type="textarea"
              ></el-input>
            </el-form-item>
          </div>
          <div id="three" style="min-height: 450px">
            <div class="formTitle"><span></span>线索资源</div>
            <div class="source">
              <div>图片：</div>
              <div class="source_item">
                <img
                  v-for="(item, index) in ruleForm.img"
                  :key="index"
                  :src="fileIdSrc(item)"
                  @click="bigImg(item)"
                />
              </div>
              <div>视频：</div>
              <div class="source_item">
                <video
                  v-for="(item, index) in ruleForm.mp4"
                  :key="index"
                  style="width: 50%"
                  :src="fileIdSrc(item)"
                  controls="controls"
                ></video>
              </div>
              <div>音频：</div>
              <div class="source_item">
                <audio
                  v-for="(item, index) in ruleForm.mp4"
                  :key="index"
                  style="width: 50%"
                  :src="fileIdSrc(item)"
                  controls="controls"
                ></audio>
              </div>
            </div>
          </div>
        </h-anchor>
      </template>
      <template v-if="status == 2">
        <el-form-item label="核实状态" prop="card">
          <!-- <el-input v-model="ruleForm.verify.verifyStats"></el-input> -->
          <!-- <h-selectcode
            type="zaxf_verify_stats"
            v-model="ruleForm.verify.verifyStats"
            placeholder="核实状态"
          ></h-selectcode> -->
          <el-select
            v-model="ruleForm.verify.verifyStats"
            placeholder="状态"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in dictList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核实备注">
          <el-input
            type="textarea"
            show-word-limit
            :maxlength="50"
            :min="2"
            v-model="ruleForm.verify.verifyDescribe"
          ></el-input>
        </el-form-item>
      </template>
    </el-form>
    <template #footer>
      <template v-if="!isDisabled">
        <h-button type="primary" @click="submitForm(ruleFormRef)"
          >保存</h-button
        >
        <h-button @click="formVisible = false">取消</h-button>
      </template>
    </template>

    <h-big-picture
      v-if="imgDetialUrl"
      :pictureUrl="imgDetialUrl"
      v-model:visible="imgDetial"
    ></h-big-picture>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  computed,
  toRefs,
  watchEffect,
  ref,
  nextTick,
} from "vue";
import util from "@util/js";
import Validate from "@/utils/validate.js";
import { getDict } from "@/api/constant";
import { ElMessage } from "element-plus";
import _ from "lodash";
import { getRoleSelect } from "@/api/system/role";
import { userVerify } from "@/api/prevention/prevention.js";
export default defineComponent({
  name: "userForm",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 3, // 2 核实；3 只读
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const ruleFormRef = ref();
    const validate = new Validate(ruleFormRef.value);
    const state = reactive({
      formVisible: false,
      imgURL: window.imgURL,
      ruleForm: {
        verify: {
          id: props.form.id,
          verifyStats: "",
          verifyDescribe: "",
        },
      },
      obj: {},
      ruleFormBack: {},
      formTitle: "",
      dictList: [],
      imgDetial: false,
      idList: [
        { name: "上报人信息", id: "one", icon: "icon-shenfenzheng" },
        { name: "线索信息", id: "two", icon: "icon-invite" },
        { name: "线索资源", id: "three", icon: "icon-shuidianbiaoguanli" },
      ],
      imgDetialUrl: null,
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    // 初始化表单
    const initForm = () => {
      const form = { ...state.ruleForm, ...props.form };
      (form.img = []),
        (form.mp4 = []),
        (form.mp3 = []),
        form.fileUrls &&
          form.fileUrls.forEach((element) => {
            const type = element.split(".");
            if (type[1] == "png" || type[1] == "jpg") {
              form.img.push(element);
            } else if (type[1] == "mp4") {
              form.mp4.push(element);
            } else if (type[1] == "mp3") {
              form.mp3.push(element);
            }
          });
      state.ruleForm = _.cloneDeep(form);
    };
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
      const types = [2, 3];
      if (types.includes(props.status)) {
        initForm();
      }
      if (props.status === 2) {
        state.formTitle = "核实线索";
      } else if (props.status === 3) {
        state.formTitle = "线索详情";
      }
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    // 禁用
    const isDisabled = computed(() => {
      return props.status === 3;
    });
    const refData = toRefs(state);

    // 保存表单数据
    const submitForm = (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          const form = _.cloneDeep(state.ruleForm.verify);
          util.formatForm(form);
          const res = await userVerify(form);
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("操作成功");
            context.emit("submit");
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    const close = () => {
      state.ruleForm = _.cloneDeep(state.ruleFormBack);
      resetForm(ruleFormRef.value);
    };
    const getDictAxios = async () => {
      const res = await getDict("zaxf_verify_stats");
      res.dict = res.dict.filter((item) => {
        return item.code !== "0";
      });
      state.dictList = res.dict;
    };
    getDictAxios();
    const fileIdSrc = (val) => {
      return val ? state.imgURL + val : "@/assets/images/moren.png";
    };
    const bigImg = (val) => {
      state.imgDetial = true;
      state.imgDetialUrl = fileIdSrc(val);
    };
    return {
      ...refData,
      submitForm,
      isDisabled,
      resetForm,
      close,
      ruleFormRef,
      fileIdSrc,
      bigImg,
    };
  },
});
</script>
<style lang="scss" scoped>
.userForm {
  max-height: 500px;
  overflow: auto;
  .anchor {
    max-height: 480px;
  }
  .formTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      width: 3.5px;
      height: 16px;
      background-color: #5584ff;
      margin-right: 10px;
    }
  }
  .source {
    padding: 0 40px;
    .source_item {
      width: 100%;
      min-height: 150px;
      @include flex-col-c-c;
    }
    img {
      width: 150px;
      height: 100px;
      margin: 15px 0;
    }
    video {
      width: 250px;
      height: 150px;
      margin: 15px 0;
    }
    audio {
      margin: 15px 0;
    }
  }
}
</style>
